<template>
  <div
    v-if="croppers.length > 0"
    class="image-search-header"
  >
    <Image
      class="image-search-header__main"
      :src="filter.imageAddress"
    />
    <div class="image-search-header__line" />
    <div class="image-search-header__list">
      <div class="image-search-header__title">
        Relate similar searches
      </div>
      <div class="image-search-header__items">
        <div
          v-for="(item, index) in croppers"
          :class="{
            'image-search-header-item': true,
            'image-search-header-item--active': selected === index,
          }"
          @click="onCropperChange(item, index)"
        >
          <img
            class="image-search-header-item__border"
            src="@/assets/item_body_border.svg"
            alt=""
          >
          <div class="image-search-header-item__image">
            <img
              :src="item.imgUrl"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Image } from '@/components/Image'
import { buriedPointUtil, gaAnalytics } from '@/utils/utils'
import { useProductList } from '../hooks/useProductList'

const { filter, croppers, onReset } = useProductList()

const selected = ref(0)

const onCropperChange = async (item, index) => {
  selected.value = index
  gaAnalytics('p_search_click', 'p_search_click')
  buriedPointUtil({ eventId: 'PSI201' })

  filter.region = item.coordinate.join(',')
  onReset()
}
</script>

<style lang="less" scoped>
.image-search-header {
  padding-top: 32px;
  padding-bottom: 13px;
  display: flex;
  align-items: center;
  gap: 24px;
  border-bottom: 1px solid #EBF1F5;

  &__main {
    width: 104px;
    height: 104px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    border: 1px solid #EBF1F5;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &__line {
    width: 0.5px;
    height: 80px;
    background-color: #EBF1F5;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__title {
    font-family: mon-600;
    letter-spacing: -0.2px;
    font-size: 12px;
    color: #232323;
  }

  &__items {
    gap: 12px;
    display: flex;
  }

  &-item {
    width: 68px;
    height: 68px;
    background-color: #ebebeb;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    position: relative;
    border: 1px solid #EBF1F5;

    &__image {
      z-index: 1;
      width: 68px;
      height: 68px;
      position: absolute;

      img {
        width: 68px;
        height: 68px;
        border-radius: 8px;
        object-fit: contain;
      }
    }

    &__border {
      z-index: 2;
      position: absolute;
      opacity: 0;
      width: 100%;
      max-height: unset;
      object-fit: cover;
    }

    &--active &__border {
      opacity: 1;
    }
  }
}
</style>
